<template>
    <div :name="name" class="secret-label">
<!--        <input class="input" :name="name" :placeholder="placeholder" :readonly="readonly" :type="newShowSecret ? 'text' : 'password'" v-model="newValue" @blur="$emit('blur')" @focus="$emit('focus')"/>-->

        <span>{{ newShowSecret ? newValue : "**********" }}</span>
        <button name="visibility-button" class="material-icons" @click="toggleShowSecret">{{ newShowSecret ? 'visibility_off' : 'visibility' }}</button>

<!--        <button type="button" v-on:click="toggleShowSecret">{{ newShowSecret ? 'hide' : 'show' }}</button>-->
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'displaySecretSmall',
    mixins: [
        Default
    ],
    props: ['name', 'showSecret', 'value'],
    data() {
        return {
            newValue: '',
            newShowSecret: false
        };
    },
    created() {
        this.newValue = this.value;
        this.newShowSecret = this.showSecret;
    },
    methods: {
        toggleShowSecret: function() {
            this.newShowSecret = !this.newShowSecret;

            this.$emit('toggleSecret');
        }
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal !== oldVal)
                this.newValue = newVal;
        },
        newValue: function(newVal, oldVal) {
            this.$emit('input', newVal);
        },
        showSecret: function() {
            this.newShowSecret = this.$props.showSecret;
        }
    }
};
</script>

<style lang="scss" scoped>
    .secret-label {
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: minmax(4em, max-content) 40px;

        [name="visibility-button"] {
            cursor: pointer;
            border: unset;
            background: unset;
            outline: unset;
            padding: 0;
        }
    }
</style>
